export const ORG_BILDTVAPP = "BILDTVAPP";
export const DEFAULT_BRAND_SETTINGS: BrandSettings = {
  id: "default",
  theme: "default",
  locale: "de_de",
};

export type BrandSettings = {
  id: string;
  locale: string;
  theme: string;
  xHandle?: string;
};

export type Organization = BrandSettings & {
  categories?: BrandSettings[];
};

export const organizations: Organization[] = [
  {
    id: "WELT",
    theme: "welt",
    xHandle: "welt",
    categories: [
      { id: "icon", theme: "icon", xHandle: "ICONISTbyicon", locale: "de_de" },
    ],
    locale: "de_de",
  },
  { id: "BILD", theme: "bild", xHandle: "bild", locale: "de_de" },
  {
    id: "BILD-BOOKS",
    theme: "default",
    locale: "de_de",

    categories: [
      {
        id: "travelbook",
        theme: "bild_travelbook",
        xHandle: "travelbook_de",
        locale: "de_de",
      },
      {
        id: "fitbook",
        theme: "bild_fitbook",
        xHandle: "fitbook_de",
        locale: "de_de",
      },
      {
        id: "stylebook",
        theme: "bild_stylebook",
        xHandle: "stylebook_de",
        locale: "de_de",
      },
      {
        id: "techbook",
        theme: "bild_techbook",
        xHandle: "techbook",
        locale: "de_de",
      },
      {
        id: "myhomebook",
        theme: "bild_myhomebook",
        xHandle: "myhomebook_de",
        locale: "de_de",
      },
    ],
  },
  { id: "AUBI", theme: "aubi", xHandle: "autobild", locale: "de_de" },
  { id: "COBI", theme: "cobi", xHandle: "COMPUTERBILD", locale: "de_de" },
  { id: "SPOBI", theme: "spobi", xHandle: "SPORTBILD", locale: "de_de" },
  { id: "BZ", theme: "bild", xHandle: "bz", locale: "de_de" },
  {
    id: "BRANDSTUDIO",
    theme: "default",
    locale: "de_de",
    categories: [
      {
        id: "bild-brand",
        theme: "bild_brandstory",
        xHandle: "bild",
        locale: "de_de",
      },
      {
        id: "bild-product-advertorial",
        theme: "bild_productstory",
        xHandle: "bild",
        locale: "de_de",
      },
      {
        id: "books-travelbook-brand",
        theme: "bild_travelbook",
        xHandle: "travelbook_de",
        locale: "de_de",
      },
      {
        id: "books-fitbook-brand",
        theme: "bild_fitbook",
        xHandle: "fitbook_de",
        locale: "de_de",
      },
      {
        id: "books-stylebook-brand",
        theme: "bild_stylebook",
        xHandle: "stylebook_de",
        locale: "de_de",
      },
      {
        id: "books-techbook-brand",
        theme: "bild_techbook",
        xHandle: "techbook",
        locale: "de_de",
      },
      {
        id: "books-myHomebook-brand",
        theme: "bild_myhomebook",
        xHandle: "myhomebook_de",
        locale: "de_de",
      },
      {
        id: "welt-brand",
        theme: "welt_brandstory",
        xHandle: "welt",
        locale: "de_de",
      },
      {
        id: "welt-product-advertorial",
        theme: "welt_productstory",
        xHandle: "welt",
        locale: "de_de",
      },
      {
        id: "manschaftsbus",
        theme: "manschaftsbus",
        locale: "de_de",
      },
    ],
  },
  {
    id: "MEDIAPIONEER",
    theme: "mediapioneer",
    xHandle: "mediapioneercom",
    locale: "de_de",
  },
  {
    id: "MUSIKEXPRESS",
    theme: "musikexpress",
    xHandle: "musikexpressde",
    locale: "de_de",
  },
  { id: ORG_BILDTVAPP, theme: "bild", xHandle: "bild", locale: "de_de" },
  {
    id: "ROLLINGSTONE",
    theme: "rollingstone",
    xHandle: "rollingstoneDE",
    locale: "de_de",
  },
  {
    id: "METALHAMMER",
    theme: "metalhammer",
    xHandle: "metalhammer_de",
    locale: "de_de",
  },
  {
    id: "RINGIERAXELSPRINGER",
    theme: "default",
    locale: "pl_pl",
  },
  {
    id: "WELT_CONTRAST",
    theme: "welt_contrast",
    locale: "de_de",
  },
];

export const getBrand = (
  organizationId: string,
  categoryId?: string
): BrandSettings => {
  const organization = organizations.find(
    (organization: Organization) =>
      organization.id === organizationId.toUpperCase()
  );

  if (organization && categoryId) {
    const category = organization.categories?.find(
      (category: BrandSettings) => category.id === categoryId.toLowerCase()
    );
    return category ?? organization;
  }

  return organization ?? DEFAULT_BRAND_SETTINGS;
};
